/**
 * Load search widget style on DOM Head
 * @returns {HTMLLinkElement} link element
 */

/**
 * To load the widget from a local dev server instead of the CDN, set
 * RESERVAMOS_PUBLIC_SEARCH_WIDGET_LOCAL_URL in .env (e.g. http://localhost:8080)
 * and run the search-widget project — it serves /search.js and /search.css.
 *
 * TODO: Remove this local-dev override once the search-widget changes from
 * ft/gratuities-childinarms-options ship to the CDN. Revert by restoring the
 * unconditional `https://widgets.reservamos.mx/...` URLs in the loaders below
 * and removing RESERVAMOS_PUBLIC_SEARCH_WIDGET_LOCAL_URL from local .env files.
 */
const SEARCH_WIDGET_LOCAL_URL = process.env.RESERVAMOS_PUBLIC_SEARCH_WIDGET_LOCAL_URL;

/**
 *  Load search widget style on DOM Head
 * @param {String} version
 * @returns
 */
export const loadSearchWidgetStyle = (version) => {
  // Load styles
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = SEARCH_WIDGET_LOCAL_URL
    ? `${SEARCH_WIDGET_LOCAL_URL}/search.css`
    : `https://widgets.reservamos.mx/search/${version}/search.css`;
  document.head.appendChild(link);
  return link;
};

/**
 * Load search widget script on DOM
 * @returns {HTMLScriptElement} script element
 */
export const loadSearchWidgetScript = (version, useDynamicLoad) => {
  // Load scripts
  const script = document.createElement('script');
  script.src = SEARCH_WIDGET_LOCAL_URL
    ? `${SEARCH_WIDGET_LOCAL_URL}/search.js`
    : `https://widgets.reservamos.mx/search/${version}/search.js`;
  if (useDynamicLoad) script.dataset.dynamicWidgetCreation = `true`;
  script.async = true;
  document.body.appendChild(script);
  return script;
};
